import { TextField } from "@material-ui/core";
import { makeStyles, Theme } from "@material-ui/core/styles";
import { withStyles } from "@material-ui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  dialogContentStyles: {
    padding: "8px 24px 24px 24px",
    display: "flex",
    flexDirection: "column",
  },
  radioContainer: {
    borderRadius: 8,
    borderWidth: "1px",
    borderStyle: "solid",
  },
}));

export const CustomTextField = withStyles({
  root: {
    "& .MuiOutlinedInput-input": {
      padding: "24px 14px",
      fontWeight: 600,
    },
    "& .MuiOutlinedInput-input:disabled": {
      color: "#DEDEDE !important",
      borderColor: "#DEDEDE !important",
    },
    "& .MuiInputLabel-outlined": {
      transform: "translate(14px, 16px) scale(1)",
    },
    "& .MuiInputLabel-outlined.MuiInputLabel-shrink": {
      transform: "translate(14px, -7px) scale(0.75)",
    },
    "& .Mui-focused": {
      color: "#000000",
    },
    "& .MuiInputBase-input:placeholder-shown + fieldset": {
      borderColor: "#E0E0E0 !important",
    },
    "& .MuiInputBase-input:not(:placeholder-shown) + fieldset": {
      borderColor: "#000000 !important",
    },
    "& .MuiInputBase-input:placeholder-shown:disabled + fieldset": {
      borderColor: "#DEDEDE !important",
    },
    "& .MuiInputBase-input:not(:placeholder-shown):disabled + fieldset": {
      borderColor: "#DEDEDE !important",
    },
    "& .MuiInputBase-input:focus + fieldset": {
      borderColor: "#000000 !important",
    },
  },
})(TextField);
